"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgF5 = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M3 6.01h4v11.992H3V6.01zM13 5.998h4v6.994h-4V5.998zM7 6.01h4.086v1.992H7V6.01z' }),
    react_1.default.createElement("path", { d: 'M6.957 11h4.086v1.992H6.957V11zM17 5.998h4V7.99h-4V5.998z' }),
    react_1.default.createElement("path", { d: 'M17 5.998h4V7.99h-4V5.998zM13 16.002h6v1.992h-6v-1.992zM17 11h4v1.992h-4V11z' }),
    react_1.default.createElement("path", { d: 'M21 12.006v5.996h-2.917v-5.996H21z' }))); };
exports.default = SvgF5;
//# sourceMappingURL=F5.js.map